<div class="row" searchPraticheInput #searchPratiche [placeholder]="'Parte, etc...'"
    [soloPratiche]="false"  (onReturn)="praticheTrovate($event);" (onReload)="praticheTrovate($event, true);"
    [ordineAscendente]="true"></div>

<div class="ricerca resultContainer" *ngIf="pratiche.length > 0">
    <ul *ngIf="pratiche.length > 0"  class="pratiche">
        <ng-template ngFor let-pratica [ngForOf]="pratiche">
            <li istanza-risultato_pratica [disableSelect]="disableSave" (onNavigate)="onReturn.emit(true)" [pratica]="pratica" [reset]="resetPrecedenti" [location]="'modal'"
                [praticaCopyInfo]="praticaCopyInfo" (onReturn)="addPratichePrecedenti($event)"
                (onReturnCopy)="addPraticheCopyInfo($event)"></li>
        </ng-template>
    </ul>
    <div class="row" *ngIf="searchResponse?.numeroPraticheTotali > pratiche.length">
        <p class="allinea_centro col-sm-12">
            <a href="javascript:void(0);" (click)="reloadSearch()"> <strong>Carica
                    altri risultati</strong></a>
        </p>
    </div>
    <div class="row" *ngIf="pratiche.length == 0">
        <p class="allinea_centro coll-sm-12">
            <strong>La ricerca non ha prodotto risultati</strong>
        </p>
    </div>
</div>


<div class="ricerca resultContainer" *ngIf="emptyResult">

    <div class="row">
        <p class="allinea_centro coll-sm-12">
            <strong>La ricerca non ha prodotto risultati</strong>
        </p>
    </div>
</div>


<div class="row" *ngIf="pratiche?.length > 0 && !disableSave">
    <p class="col-sm-3 col-xs-6">
        <button type="button" class="btn btn-outline-secondary btn-block"
            (click)="resetPrec();">Reset</button>
    </p>
    <p  class="col-sm-3 col-xs-6 col-sm-offset-6">
        <button [disabled]="pratichePrecedenti.length === 0" type="button" class="btn btn-primary btn-block"
            (click)="salvaPrecedenti();">Salva</button>
    </p>
</div>